import { getMyUser, getOrganization, getMyMembershipForBubble } from '@/store'

// ------------------------------------------------------------------
// ----- ORG PERMISSIONS --------------------------------------------
// ------------------------------------------------------------------

// Org-level Roles
export const SYSTEM = 'system'
export const SUPPORT = 'support'
export const ADMIN = 'admin'
export const MANAGER = 'manager'
export const USER = 'user'
export const orgRoles = { SUPPORT, ADMIN, MANAGER, USER }

const orgRoleHierarchy = {
	[SYSTEM]: 5,
	[SUPPORT]: 4,
	[ADMIN]: 3,
	[MANAGER]: 2,
	[USER]: 1,
}

// Org-level permissions
export const ADD_USER = 'add_user'
export const CREATE_API_TOKENS = 'create_api_tokens'
export const CREATE_DM = 'create_dm'
export const CREATE_MULTIDM = 'create_multidm'
export const CREATE_GROUP = 'create_group'
export const DELETE_ANY_ANNOUNCEMENT = 'delete_any_announcement'
export const SEARCH_ORG = 'search_org'
export const orgPermissions = {
	ADD_USER,
	CREATE_API_TOKENS,
	CREATE_DM,
	CREATE_GROUP,
	DELETE_ANY_ANNOUNCEMENT,
	SEARCH_ORG,
}

export const orgCan = (permission) => {
	if (!permission) return false
	const me = getMyUser()
	const org = getOrganization()
	const requiredRole = orgRoleHierarchy[org[permission]] ?? 0
	const myRole = orgRoleHierarchy[me.role] ?? 0
	if (!requiredRole || !myRole) return false
	return myRole >= requiredRole
}

export const shouldGrantOrgPermission = (permission) => {
	if (!orgPermissions[permission]) return false
	const grant = resolveGrant(permission)
	const org = getOrganization()
	return org[grant] ?? false
}

// ------------------------------------------------------------------
// ----- CHAT PERMISSIONS -------------------------------------------
// ------------------------------------------------------------------

// Chat-level roles
export const OWNER = 'owner'
export const MEMBER = 'member'
export const chatRoles = { OWNER, MEMBER }

const chatRoleHierarchy = {
	[SYSTEM]: 3,
	[OWNER]: 2,
	[MEMBER]: 1,
}

// Chat-level permissions
export const ASSIGN_TASK = 'assign_task'
export const CREATE_ANNOUNCEMENT = 'create_announcement'
export const CREATE_MESSAGE = 'create_message'
export const CREATE_VIDEOSESSION = 'create_videosession'
export const ADD_MEMBER = 'addmember'
export const CHANGE_CATEGORY = 'changecategory'
export const CHANGE_TITLE = 'changetitle'
export const LEAVE_GROUP = 'leavegroup'
export const REMOVE_MEMBER = 'removemember'
export const VIDEOSESSION_RECORD_CLOUD = 'videosessionrecordcloud'
export const VIDEOSESSION_RECORD_LOCAL = 'videosessionrecordlocal'
export const DELETE_ANY_MESSAGE = 'deleteanymessage'
export const DELETE_GROUP = 'deletegroup'
export const PIN_MESSAGE = 'pin_message'
// new rest-style chat permissions
export const CREATE_POLLS = 'create_polls'
export const CREATE_MEETING = 'create_meeting'
export const RECORD_MEETINGS = 'record_meetings'
export const UPDATE_CATEGORY = 'update_category'
export const UPDATE_TITLE = 'update_title'
export const DELETE_CHAT = 'delete_chat'
export const CREATE_MEMBERSHIPS = 'create_memberships'
export const DELETE_MEMBERSHIPS = 'delete_memberships'
export const UPDATE_MEMBERSHIP_ROLE = 'update_membership_role'
export const DELETE_OWN_MEMBERSHIP = 'delete_own_membership'

export const chatPermissions = {
	ASSIGN_TASK,
	CREATE_ANNOUNCEMENT,
	CREATE_MESSAGE,
	CREATE_VIDEOSESSION,
	ADD_MEMBER,
	CHANGE_CATEGORY,
	CHANGE_TITLE,
	LEAVE_GROUP,
	REMOVE_MEMBER,
	VIDEOSESSION_RECORD_CLOUD,
	VIDEOSESSION_RECORD_LOCAL,
	DELETE_ANY_MESSAGE,
	DELETE_GROUP,
	PIN_MESSAGE,
}

export const chatCan = (chat, permission) => {
	if (!chat || !permission) return false
	const membership = getMyMembershipForBubble(chat.id)
	if (!membership) return false
	const requiredRole = chatRoleHierarchy[chat[permission]] ?? 0
	const myRole = chatRoleHierarchy[membership.role] ?? 0
	if (!requiredRole || !myRole) return false
	return myRole >= requiredRole
}

const resolveGrant = (permission) => {
	if (!permission) return null
	return permission.includes('_') ? `grant_${permission}` : `grant${permission}`
}

export const shouldGrantChatPermission = (chat, permission) => {
	if (!chat || !chatPermissions[permission]) return false
	const grant = resolveGrant(permission)
	return chat[grant] ?? false
}
